import React, { createContext, useContext, useState } from 'react';

// Create a context for UI state
const UIContext = createContext({
  isWorkshopModalOpen: false,
  setWorkshopModalOpen: () => {},
});

export const UIProvider = ({ children }) => {
  const [isWorkshopModalOpen, setWorkshopModalOpen] = useState(false);

  return (
    <UIContext.Provider value={{ isWorkshopModalOpen, setWorkshopModalOpen }}>
      {children}
    </UIContext.Provider>
  );
};

export const useUI = () => useContext(UIContext);

export default UIContext;
